import React from 'react';
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl
} from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { CSSTransitionGroup } from 'react-transition-group';
import Input from '../../components/Input';
import { formatDate, validateRequired } from '../../helpers';

class ShapeSetDetailsForm extends React.Component {
  render() {
    const { currentShapeSet, isOwner } = this.props;
    const shapeSetTypes = currentShapeSet.settings.shapeSetType;

    if (isOwner) {
      return (
        <div>
          <Row />
          <Form onSubmit={this.props.handleSubmit}>
            <Row>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type={isOwner ? 'text' : 'static'}
                  placeholder="Catchment Set name"
                  label="Catchment Set name"
                  name="name"
                  validate={validateRequired}
                />
              </Col>
            </Row>

            {!this.props.isNew && (
              <Row>
                <Col sm={12} className="form-input">
                  <Field
                    component={Input}
                    type="toggle"
                    name="isArchived"
                    label="Active"
                    reverse
                  />
                </Col>
              </Row>
            )}

            {this.props.isInternalAdminUser && (
              <Row>
                <Col sm={12} className="form-input">
                  <FormGroup>
                    <Field
                      component={Input}
                      type="radioGroup"
                      name="shapeSetTypeId"
                      label="Type"
                      normalize={value => parseInt(value, 10)}
                      options={shapeSetTypes}
                      validate={validateRequired}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            {this.props.context === 'global' && (
              <Row>
                <Col sm={12} className="form-input">
                  <Field
                    component={Input}
                    type="toggle"
                    name="shareWithAllIndustries"
                    label="Shared with all industries"
                  />
                </Col>
              </Row>
            )}
            {!this.props.isNew && (
              <div>
                <Row>
                  <Col sm={12} className="form-input">
                    <ControlLabel>Date created</ControlLabel>
                    <FormControl.Static>
                      {formatDate(currentShapeSet.dateCreated)}
                    </FormControl.Static>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} className="form-input">
                    <ControlLabel>Last changed</ControlLabel>
                    <FormControl.Static>
                      {formatDate(currentShapeSet.dateUpdated)}
                    </FormControl.Static>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} className="form-input">
                    <ControlLabel>Last changed by</ControlLabel>
                    <FormControl.Static>
                      {currentShapeSet.lastChangedBy}
                    </FormControl.Static>
                  </Col>
                </Row>
              </div>
            )}
            <Row>
              <Col sm={2} className="table-header">
                <Button
                  bsStyle="primary"
                  type="submit"
                  disabled={this.props.isSaving}
                >
                  {this.props.isSaving ? 'Saving...' : 'Save'}
                </Button>
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={12}>
                <CSSTransitionGroup
                  transitionName="fade"
                  transitionEnterTimeout={300}
                  transitionLeaveTimeout={300}
                >
                  {this.props.successMsg && (
                    <p className="text-success">{this.props.successMsg}</p>
                  )}
                </CSSTransitionGroup>
              </Col>
            </Row>
          </Form>
          {this.props.errorMsg && (
            <div className="alert alert-danger">{this.props.errorMsg}</div>
          )}
        </div>
      );
    } else {
      const shapeSetType = shapeSetTypes.find(
        t => t.id === currentShapeSet.shapeSetTypeId
      );
      return (
        <div>
          <Row>
            <Col sm={12} className="form-input">
              <ControlLabel>Catchment Set name</ControlLabel>
              <FormControl.Static>{currentShapeSet.name}</FormControl.Static>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <ControlLabel>Status</ControlLabel>
              <FormControl.Static>
                {currentShapeSet.isArchived ? 'Archived' : 'Active'}
              </FormControl.Static>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <ControlLabel>Type</ControlLabel>
              <FormControl.Static>
                {shapeSetType && shapeSetType.name}
              </FormControl.Static>
            </Col>
          </Row>
          {this.props.context === 'global' && (
            <Row>
              <Col sm={12} className="form-input">
                <ControlLabel>Shared with all Industries</ControlLabel>
                <FormControl.Static>
                  {currentShapeSet.shareWithAllIndustries ? 'Yes' : 'No'}
                </FormControl.Static>
              </Col>
            </Row>
          )}
          {!this.props.isNew && (
            <div>
              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Date created</ControlLabel>
                  <FormControl.Static>
                    {formatDate(this.props.currentShapeSet.dateCreated)}
                  </FormControl.Static>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Last changed</ControlLabel>
                  <FormControl.Static>
                    {formatDate(this.props.currentShapeSet.dateUpdated)}
                  </FormControl.Static>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Last changed by</ControlLabel>
                  <FormControl.Static>
                    {this.props.currentShapeSet.lastChangedBy}
                  </FormControl.Static>
                </Col>
              </Row>
            </div>
          )}
        </div>
      );
    }
  }
}

// Decorate the form component
ShapeSetDetailsForm = reduxForm({
  form: 'shapeSetDetailsForm' // a unique name for this form
})(ShapeSetDetailsForm);

export default ShapeSetDetailsForm;



// WEBPACK FOOTER //
// ./src/containers/shapeset/ShapeSetDetailsForm.js